<div class="profile-widget">
  <div class="profile-widget__avatar-container">
    <app-profile-avatar
      [profileAvatarUrl]="imageAvatarUrl"
    ></app-profile-avatar>
    <h3>{{ profile?.fullName }}</h3>
  </div>
  <div class="profile-widget__list">
    <div class="profile-widget__item" (click)="openModalInviteCode()">
      <div class="profile-widget__item-label-container">
        <i class="profile-widget__item-icon fa-solid fa-circle-user"></i>
        <span class="profile-widget__item-label">
          {{ 'INVITE_CODE.INVITE_CODE_TITLE' | translate }}
        </span>
      </div>
      <i class="profile-widget__arrow-icon fa-solid fa-chevron-right"></i>
    </div>

    <div
      (click)="goToPage(appRoutes['PROFILE'].fullPath)"
      class="profile-widget__item"
    >
      <div class="profile-widget__item-label-container">
        <i class="profile-widget__item-icon fa-solid fa-circle-user"></i>
        <span class="profile-widget__item-label">
          {{ 'SETTINGS.PROFILE.TITLE' | translate }}
        </span>
      </div>
      <i class="profile-widget__arrow-icon fa-solid fa-chevron-right"></i>
    </div>
    <div (click)="logout()" class="profile-widget__item">
      <div class="profile-widget__item-label-container">
        <i
          class="profile-widget__item-icon fa-solid fa-arrow-right-from-bracket"
        ></i>
        <span class="profile-widget__item-label">
          {{ 'COMPONENT.MAIN_MENU.ITEM.LOGOUT' | translate }}
        </span>
      </div>
      <i class="profile-widget__arrow-icon fa-solid fa-chevron-right"></i>
    </div>
  </div>
</div>
